import React, { Component } from 'react';
import classNames from 'classnames';

import closeIcon from '../../../assets/icons/icon_close.svg';

class CurrencyDropdown extends Component{
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      infoActive: false,
      dropdownActive: false,
      selectedCurrency: this.props.data[0]
    }
  }

  getCurrencyById(eId){
    const selectedId = parseInt(eId, 16);
    return this.props.data.filter(item => item.id === selectedId)[0]
  }

  handleChange(e) {
    const selectedCurrency = this.getCurrencyById(e);
    this.props.onChange(selectedCurrency);
    this.setState({
      dropdownActive: false,
      selectedCurrency: selectedCurrency
    })
  }

  toggleDropdown = () => {
    var activeBool = this.state.dropdownActive ? false : true;
    this.setState({
      dropdownActive: activeBool
    })
  }

  componentWillMount() {
    // set up first currency to display
    this.props.onChange(this.props.data[0])
  }

  handleInfoModal = () => {
    const infoModal = this.refs.infoModal;
    const activeState = this.state.infoActive;
    const section = this.refs.section;
    if (infoModal !== undefined && section !== undefined){
      if(activeState){
        infoModal.classList.remove(this.props.styles.infoModalActive)
        section.classList.remove(this.props.styles.containerRotate)
        this.setState({
          infoActive: false
        })
      }
      else{
        infoModal.classList.add(this.props.styles.infoModalActive)
        section.classList.add(this.props.styles.containerRotate)
        this.setState({
          infoActive: true,
          dropdownActive: false
        })
      }
    }
  }

  render() {
    const styles = this.props.styles;
    const currencyData = this.props.data;
    const activeDropdownStyle = this.state.dropdownActive ? styles.dropdownChoicesActive : null;
    const listOptions = currencyData.map((item) => {
      const activeClass = this.state.selectedCurrency.id === item.id ? styles.dropdownChoiceActive : null;
      return(
        <li key={item.id} className={activeClass} onClick={() => this.handleChange(item.id)}>{item.symbol}</li>
      );
    })
    return(
      <div ref="section" className={styles.inputItem}>
          <div className={styles.info}>
            {this.props.helpText &&
              <div>
                <img src={this.props.icon} alt="Info" onMouseDown={this.handleInfoModal} />
                <div className={styles.infoModal} ref="infoModal" onMouseDown={this.handleInfoModal}>
                  <h5>{this.props.description}</h5>
                  <p>{this.props.helpText}</p>
                  <img src={closeIcon} alt="Info" onMouseDown={this.handleInfoModal} />
                </div>
              </div>
            }
          </div>
          <div className={styles.dropdownContainer}>
            <button className={styles.dropdownButton} onClick={() => this.toggleDropdown()}>{this.state.selectedCurrency.symbol}</button>
            <ul className={classNames([styles.dropdownChoices, activeDropdownStyle])}>
              {listOptions}
            </ul>
          </div>
        <span>{this.props.unitInfo}</span>
        <span className={styles.bottom}>
          {this.props.description}
        </span>
      </div>
    );
  }
}

export default CurrencyDropdown;



// WEBPACK FOOTER //
// ./src/components/calculator/inputs/c_currency_dropdown.js